import Api from "../config/api";

export const findAllMunicipio = async (searchDTO = {}) => {
  const defaultSearchDTO = {
    pageSize: 30,
    pageNumber: 0,
    sortDir: "ASC",
  };

  const response = await Api.post("", {
    query: `
        query ($searchDTO: SearchDTOInput) {
        findAllMunicipio(searchDTO: $searchDTO) {
          last
          content {
            id
            nome
            uf
          }
        }
      }
    `,
    variables: {
      searchDTO: {
        ...defaultSearchDTO,
        ...searchDTO,
      },
    },
  });
  const { last, content } = response.data.data.findAllMunicipio;

  const customContent = content.map((municipio) => {
    const municipioComUf = `${municipio.nome} - ${municipio.uf}`;
    return {
      ...municipio,
      value: municipio.id,
      label: municipioComUf,
    };
  });

  return {
    last,
    content: customContent,
  };
};

export const findAllSujeitoAtencaoAniversariante = async (variables) => {
  const response = await Api.post("", {
    query: `
    query ($pageable: PageableDTOInput, $ativo: Boolean, $search: String, $dataInicio: LocalDate, $municipioId: Long, $dataFinal: LocalDate) {
      findAllSujeitoAtencaoAniversariante(pageable: $pageable, ativo: $ativo, search: $search, dataInicio: $dataInicio, municipioId: $municipioId, dataFinal: $dataFinal) {
        last
        totalElements
        content {
          nome
          ativo
          dataNascimento
          contato {
            email
            telefonePrincipal
            telefonePrincipalDDI
            telefoneSecundario
            telefoneSecundarioDDI
          }
          endereco {
            municipio {
              nome
              uf
            }
          }
          espanhaMunicipio {
            id
            descricao
          }
        }
      }
    }`,
    variables: variables,
  });

  return response.data.data.findAllSujeitoAtencaoAniversariante;
};

export const findAllSujeitoAtencaoAniversariantePdf = async (variables) => {
  const response = await Api.post("", {
    query: `
    query ($pageable: PageableDTOInput, $ativo: Boolean, $search: String, $dataInicio: LocalDate, $municipioId: Long, $dataFinal: LocalDate) {
      findAllSujeitoAtencaoAniversariantePdf(pageable: $pageable, ativo: $ativo, search: $search, dataInicio: $dataInicio, municipioId: $municipioId, dataFinal: $dataFinal) {
          nome
          ativo
          dataNascimento
          contato {
            email
            telefonePrincipal
            telefonePrincipalDDI
            telefoneSecundario
            telefoneSecundarioDDI
          }
          endereco {
            municipio {
              nome
              uf
            }
          }
          espanhaMunicipio {
            id
            descricao
          }
      }
    }`,
    variables: variables,
  });

  return response.data.data.findAllSujeitoAtencaoAniversariantePdf;
};

export const findAllSujeitoAtencaoQuemIndicou = async (variables) => {
  const response = await Api.post("", {
    query: `
    query ($pageable: PageableDTOInput, $ativo: Boolean, $search: String, $municipioId: Long) {
      findAllSujeitoAtencaoQuemIndicou(pageable: $pageable, ativo: $ativo, search: $search, municipioId: $municipioId) {
        last
        totalElements
        content {
          nome
          ativo
          contato {
            telefonePrincipal
            telefoneSecundario
            telefonePrincipalDDI
            telefoneSecundarioDDI
          }
          endereco {
            municipio {
              nome
              uf
            }
          }
          espanhaMunicipio {
            descricao
            id
          }
          quemIndicou
        }
      }
    }`,
    variables: variables,
  });

  return response.data.data.findAllSujeitoAtencaoQuemIndicou;
};

export const findAllSujeitoAtencaoQuemIndicouPdf = async (variables) => {
  const response = await Api.post("", {
    query: `
    query FindAllSujeitoAtencaoQuemIndicouPdf($ativo: Boolean, $search: String, $pageable: PageableDTOInput, $municipioId: Long) {
  findAllSujeitoAtencaoQuemIndicouPdf(ativo: $ativo, search: $search, pageable: $pageable, municipioId: $municipioId) {
          nome
          ativo
          contato {
            telefonePrincipal
            telefoneSecundario
            telefonePrincipalDDI
            telefoneSecundarioDDI
          }
          endereco {
            municipio {
              nome
              uf
            }
          }
          espanhaMunicipio {
            descricao
            id
          }
          quemIndicou
  }
}`,
    variables: variables,
  });

  return response.data.data.findAllSujeitoAtencaoQuemIndicouPdf;
};

export const relatorioSujeitoAtencaoQuemIndicouData = async (variables) => {
  const response = await Api.post("", {
    query: `
    query ($ativo: Boolean, $search: String, $pageable: PageableDTOInput, $dataInicio: LocalDate, $dataFinal: LocalDate) {
      relatorioSujeitoAtencaoQuemIndicouData(ativo: $ativo, search: $search, dataInicio: $dataInicio, dataFinal: $dataFinal, pageable: $pageable) {
        last
        totalElements
        content {
          quantidade
          quemIndicou
        }
      }
    }`,
    variables: variables,
  });

  return response.data.data.relatorioSujeitoAtencaoQuemIndicouData;
};

export const relatorioSujeitoAtencaoQuemIndicouDataPdf = async (variables) => {
  const response = await Api.post("", {
    query: `
    query ($ativo: Boolean, $search: String, $pageable: PageableDTOInput, $dataInicio: LocalDate, $dataFinal: LocalDate) {
      relatorioSujeitoAtencaoQuemIndicouDataPdf(ativo: $ativo, search: $search, dataInicio: $dataInicio, dataFinal: $dataFinal, pageable: $pageable) {
        
          quantidade
          quemIndicou
      }
    }`,
    variables: variables,
  });

  return response.data.data.relatorioSujeitoAtencaoQuemIndicouDataPdf;
};

export const relatorioProcedimento = async (variables) => {
  const response = await Api.post("", {
    query: `
    query ($pageableDTO: PageableDTOInput,$dataInicio: LocalDate, $dataFim: LocalDate) {
      relatorioProcedimento(pageableDTO: $pageableDTO, , dataInicio: $dataInicio, dataFim: $dataFim) {
        last
        totalElements
        content {
          procedimento
          quantidade
          valor
        }
      }
    }
      `,
    variables: variables,
  });

  return response.data.data.relatorioProcedimento;
};

export const relatorioProcedimentoTotal = async (variables) => {
  const response = await Api.post("", {
    query: `
    query ($dataInicio: LocalDate, $dataFim: LocalDate) {
      relatorioProcedimentoTotal(dataInicio: $dataInicio, dataFim: $dataFim) {
        quantidade
        valor
      }
    }
      `,
    variables: variables,
  });

  return response.data.data.relatorioProcedimentoTotal;
};

export const relatorioProcedimentoLista = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($dataInicio: LocalDate, $dataFim: LocalDate) {
        relatorioProcedimentoLista(dataInicio: $dataInicio, dataFim: $dataFim) {
          procedimento
          quantidade
          valor
        }
      }
      `,
    variables: variables,
  });

  return response.data.data.relatorioProcedimentoLista;
};

export const relatorioAgendamentosSituacao = async (variables) => {
  const response = await Api.post("", {
    query: `
        query ($search: SearchAgendamentoDTOInput, $pageableDTO: PageableDTOInput, $criacao: Long) {
          relatorioAgendamentosSituacao(search: $search, pageableDTO: $pageableDTO, criacao: $criacao) {
            totalElements
            last
            content {
              id
              nome
              horaInicio
              horaFim
              telefone
              telefoneDDI
              data
              situacao
              modoConfirmacao
              tipo {
                id
                descricao
              }
              sujeitoAtencao {
                id
                nome
              }
              convenio {
                  id
                descricao
                valorConsulta
              }
              
              profissionalSaude {
                nome
              }
              procedimento {
                procedimentos 
                valorProcedimentos
              }
              origem
            }
          }
        }`,
    variables: variables,
  });

  return response.data.data.relatorioAgendamentosSituacao;
};

export const relatorioAgendamentosSituacaoPdf = async (variables) => {
  const response = await Api.post("", {
    query: `
       query RelatorioAgendamentosSituacaoPdf($search: SearchAgendamentoDTOInput, $statusPresenca: Boolean, $criacao: Long, $pageableDTO: PageableDTOInput) {
  relatorioAgendamentosSituacaoPdf(search: $search, statusPresenca: $statusPresenca, criacao: $criacao, pageableDTO: $pageableDTO) {
              id
              nome
              horaInicio
              horaFim
              telefone
              telefoneDDI
              data
              situacao
              modoConfirmacao
              tipo {
                id
                descricao
              }
              sujeitoAtencao {
                id
                nome
              }
              convenio {
                  id
                descricao
                valorConsulta
              }
              
              profissionalSaude {
                nome
              }
              procedimento {
                procedimentos 
                valorProcedimentos
              }
              origem
  }
}`,
    variables: variables,
  });

  return response.data.data.relatorioAgendamentosSituacaoPdf;
};

export const relatorioAgendamentosRepasse = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($search: SearchAgendamentoDTOInput, $pageableDTO: PageableDTOInput) {
        relatorioAgendamentosRepasse(search: $search, pageableDTO: $pageableDTO) {
            totalElements
            last
            content {
              id
              nome
              horaInicio
              horaFim
              data
              situacao
              valorRepasseAgendamento
              tipo {
                id
                descricao
              }
              profissionalSaude {
                nome
              }
              convenio {
                id
                descricao
              }
              tipo {
                id
                descricao
              }
            }
          }
        }`,
    variables: variables,
  });

  if (response?.data?.data) {
    return response.data.data.relatorioAgendamentosRepasse;
  } else {
    throw new Error(response.data.errors[0]);
  }
};

 export const relatorioAgendamentosRepasseSintetico = async (variables) => {
   const response = await Api.post("", {
     query: `
      query RelatorioAgendamentosRepasseSintetico($search: SearchAgendamentoDTOInput) {
  relatorioAgendamentosRepasseSintetico(search: $search) {
    valorTotalAPagar
    totalAReceber
    quantidadeAgendamentos
    profissionalSaude {
      nome
      id
    }
  }
}`,
     variables: variables,
   });

   if (response?.data?.errors) {
     throw new Error(response?.data?.errors[0]?.message);
   }
   return response.data.data.relatorioAgendamentosRepasseSintetico;
 };

 export const relatorioAgendamentosRepasseSinteticoCsv = async (variables) => {
   const response = await Api.post("", {
     query: `query relatorioAgendamentosRepasseSinteticoCsv($search: SearchAgendamentoDTOInput) {
  relatorioAgendamentosRepasseSinteticoCsv(search: $search)
}`,
     variables,
   });

   if (response.data.errors) {
     throw new Erro(response.data.errors[0].message);
   }

   return response.data.data.relatorioAgendamentosRepasseSinteticoCsv;
 };

export const findAllProfissionalSaude = async (searchDTO = {}) => {
  try {
    const defaultSearchDTO = {
      ativo: true,
      pageSize: 30,
      pageNumber: 0,
      sortDir: "ASC",
      sortField: "nome",
    };

    const response = await Api.post("", {
      query: `
        query ($searchDTO: SearchProfissionalSaudeDTOInput) {
          findAllProfissionalSaude(searchDTO: $searchDTO) {
            last
            totalElements
            numberOfElements
            content {
              id
              nome
              value:id
              label:nome
            }
          }
        }
      `,
      variables: {
        searchDTO: {
          ...defaultSearchDTO,
          ...searchDTO,
        },
      },
    });

    const { last, content } = response.data.data.findAllProfissionalSaude;

    return {
      last,
      content,
    };
  } catch (error) {
    throw error;
  }
};

export const relatorioAgendamentosRepasseCsv = async (search) => {
  const response = await Api.post("", {
    query: `
      query ($search: SearchAgendamentoDTOInput) {
        relatorioAgendamentosRepasseCsv(search: $search)
      }
      `,
    variables: search,
  });

  if (response?.data?.data) {
    return response?.data?.data?.relatorioAgendamentosRepasseCsv;
  } else {
    throw new Error(response.data.errors[0]);
  }
};

export const valorConsultaAndProcedimento = async (search) => {
  const response = await Api.post("", {
    query: `
      query ($search: SearchAgendamentoDTOInput, $criacao: Long) {
        valorConsultaAndProcedimento(search: $search, criacao: $criacao) {
          valorTotalConsultas
          valorTotalProcedimentos
        }
      }
      `,
    variables: search,
  });

  if (response?.data?.data) {
    return response?.data?.data?.valorConsultaAndProcedimento;
  } else {
    throw new Error(response.data.errors[0]);
  }
};

export const relatorioAgendamentosRepasseValorTotal = async (search) => {
  const response = await Api.post("", {
    query: `
      query ($search: SearchAgendamentoDTOInput) {
        relatorioAgendamentosRepasseValorTotal(search: $search) 
      }
      `,
    variables: { search },
  });

  if (response?.data?.data) {
    return response.data.data.relatorioAgendamentosRepasseValorTotal;
  } else {
    throw new Error(response.data.errors[0]);
  }
};

export const findAllProcedimentoSolicitado = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($profissionalSaudeId: Long, $procedimentoId: UUID, $agendado: Boolean, $pageableDTO: PageableDTOInput, $dataHoraInicio: LocalDateTime, $dataHoraFim: LocalDateTime) {
        relatorioProcedimentosSolicitados(profissionalSaudeId: $profissionalSaudeId, procedimentoId: $procedimentoId, agendado: $agendado, pageableDTO: $pageableDTO, dataHoraInicio: $dataHoraInicio, dataHoraFim: $dataHoraFim) {
          last
          totalElements
          content {
            profissionalSaude {
              id
              nome
            }
            agendado
            procedimento {
              id
              nome
            }
            dataHoraLancamento
            valorCusto
          }
        }
      }
    `,
    variables,
  });

  const { last, content, totalElements } = response?.data?.data?.relatorioProcedimentosSolicitados;


  return {
    last,
    content,
    totalElements,
  };
}

export const relatorioProcedimentosSolicitadosPdf = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($profissionalSaudeId: Long, $procedimentoId: UUID, $agendado: Boolean, $pageableDTO: PageableDTOInput, $dataHoraInicio: LocalDateTime, $dataHoraFim: LocalDateTime) {
        relatorioProcedimentosSolicitadosPdf(profissionalSaudeId: $profissionalSaudeId, procedimentoId: $procedimentoId, agendado: $agendado, pageableDTO: $pageableDTO, dataHoraInicio: $dataHoraInicio, dataHoraFim: $dataHoraFim) {
            profissionalSaude {
              id
              nome
            }
            agendado
            procedimento {
              id
              nome
            }
            dataHoraLancamento
            valorCusto
          
        }
      }
    `,
    variables,
  });

  return response?.data?.data?.relatorioProcedimentosSolicitadosPdf;
}

export const totalProcedimentosSolicitados = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($profissionalSaudeId: Long, $procedimentoId: UUID, $agendado: Boolean, $pageableDTO: PageableDTOInput, $dataHoraInicio: LocalDateTime, $dataHoraFim: LocalDateTime) {
        relatorioProcedimentosSolicitados(profissionalSaudeId: $profissionalSaudeId, procedimentoId: $procedimentoId, agendado: $agendado, pageableDTO: $pageableDTO, dataHoraInicio: $dataHoraInicio, dataHoraFim: $dataHoraFim) {
          totalElements
        }
      }
    `,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message)
  }

  const { totalElements } = response?.data?.data?.relatorioProcedimentosSolicitados;

  return {
    totalElements,
  };
}

export const relatorioProcedimentosSolicitadosCsv = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($profissionalSaudeId: Long, $procedimentoId: UUID, $agendado: Boolean, $dataHoraInicio: LocalDateTime, $dataHoraFim: LocalDateTime) {
        relatorioProcedimentosSolicitadosCsv(profissionalSaudeId: $profissionalSaudeId, procedimentoId: $procedimentoId, agendado: $agendado, dataHoraInicio: $dataHoraInicio, dataHoraFim: $dataHoraFim) 
      }
    `,
    variables,
  });
  if (response.data.errors) {
    throw new Error(response.data.errors[0].message)
  }
  return response?.data?.data?.relatorioProcedimentosSolicitadosCsv;
}

export const countProcedimentosSolicitados = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($profissionalSaudeId: Long, $procedimentoId: UUID, $agendado: Boolean, $dataHoraInicio: LocalDateTime, $dataHoraFim: LocalDateTime) {
        countProcedimentosSolicitados(profissionalSaudeId: $profissionalSaudeId, procedimentoId: $procedimentoId, agendado: $agendado, dataHoraInicio: $dataHoraInicio, dataHoraFim: $dataHoraFim) 
      }
    `,
    variables,
  });
  if (response.data.errors) {
    throw new Error(response.data.errors[0].message)
  }
  return response?.data?.data?.countProcedimentosSolicitados;
}

export const findAllRelatorioCID = async (variables) => {
  const response = await Api.post("", {
    query: `
      query RelatorioAgendamentosByCid10Subcategoria($profissionalSaudeId: Long, $dataFim: LocalDate, $cid10SubcategoriaId: Long, $dataInicio: LocalDate, $situacoes: [AgendamentoSituacao], $sujeitoAtencaoId: UUID) {
        relatorioAgendamentosByCid10Subcategoria(profissionalSaudeId: $profissionalSaudeId, dataFim: $dataFim, cid10SubcategoriaId: $cid10SubcategoriaId, dataInicio: $dataInicio, situacoes: $situacoes,sujeitoAtencaoId: $sujeitoAtencaoId) {
          quantidade
          descricao
        }
      }
      `,
    variables,
  });
  if (response.data.errors) {
    throw new Error(response.data.errors[0].message)
  }
  return response.data.data.relatorioAgendamentosByCid10Subcategoria;
}

export const findAllCid10Subcategoria = async (variables) => {
  const response = await Api.post("", {
    query: `
    query FindAllCid10Subcategoria($searchDto: SearchDTOInput) {
      findAllCid10Subcategoria(searchDTO: $searchDto) {
        last
        totalElements
        content {
          descricao
          id
          codigo
          descricaoAbreviada
        }
      }
    }
      `,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message)
  }

  return response.data.data.findAllCid10Subcategoria;
}

export const relatorioUltimasConsultas = async (variables) => {

  const response = await Api.post("", {
    query: `
    query RelatorioUltimasConsultas(
    $profissionalId: Long, 
    $periodo: Long, 
    $convenioId: Long,
    $search: String,
    $municipioId: Long,
    $pageableDTO: PageableDTOInput
     ) {
       relatorioUltimasConsultas(
      profissionalId: $profissionalId, 
      periodo: $periodo,
      convenioId:  $convenioId,
      search: $search,
      municipioId: $municipioId,
      pageableDTO: $pageableDTO) {
        content{
        dataUltimoAtendimento
        nome
        idade
        profissional
        contatoEmail
        contatoTelefonePrincipal
        contatoTelefonePrincipalDdi
        dataNascimento
        nomeMunicipio
        descricaoConvenio
  }
        last
        totalElements
      }
    }
      `,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message)
  }

  return response.data.data.relatorioUltimasConsultas;
}

export const relatorioUltimasConsultasPdf = async (variables) => {

  const response = await Api.post("", {
    query: `
    query RelatorioUltimasConsultasPdf(
    $profissionalId: Long, 
    $periodo: Long, 
    $convenioId: Long,
    $search: String,
    $municipioId: Long,
     ) {
       relatorioUltimasConsultasPdf(
      profissionalId: $profissionalId, 
      periodo: $periodo,
      convenioId:  $convenioId,
      search: $search,
      municipioId: $municipioId,
      ) {
        
        dataUltimoAtendimento
        nome
        idade
        profissional
        contatoEmail
        contatoTelefonePrincipal
        contatoTelefonePrincipalDdi
        dataNascimento
        nomeMunicipio
        descricaoConvenio
  
      
      }
    }
      `,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message)
  }

  return response.data.data.relatorioUltimasConsultasPdf;
}


export const relatorioUltimasConsultasCsv = async (variables) => {

  const response = await Api.post("", {
    query: `
    query (
   $profissionalId: Long, 
    $periodo: Long, 
    $convenioId: Long,
    $search: String,
    $municipioId: Long,
    ) {
      relatorioUltimasConsultasCsv(
      profissionalId: $profissionalId, 
      periodo: $periodo,
      convenioId:  $convenioId,
      search: $search,
      municipioId: $municipioId,
      )
    }
    `,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message)
  }

  return response.data.data.relatorioUltimasConsultasCsv;
}

export const relatorioAgendamentoProducaoPorProfissional = async (variables) => {

  const response = await Api.post("", {
    query: `
      query(
    $dataInicio: LocalDate, 
    $dataFim: LocalDate, 
    $pageableDto: PageableDTOInput, 
    $situacoes: [AgendamentoSituacao], 
    $profissionalSaudeId: Long, 
    $tipoData: TipoDataRelatorio){
      relatorioAgendamentoProducaoPorProfissional(
      pageableDTO: $pageableDto,
      dataInicio: $dataInicio, 
      dataFim: $dataFim, 
      situacoes: $situacoes, 
      profissionalSaudeId: $profissionalSaudeId, 
      tipoData: $tipoData){
        last
        totalElements
        content {
          profissionalSaude
          situacao
          quantidade
        }
      }
    }
    `,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message)
  }
  return response.data.data.relatorioAgendamentoProducaoPorProfissional;
}

export const relatorioAgendamentoProducaoPorProfissionalCsv = async (variables) => {

  const response = await Api.post("", {
    query: `
  query($tipoData: TipoDataRelatorio, $pageableDto: PageableDTOInput, $situacoes: [AgendamentoSituacao], $dataInicio: LocalDate, $dataFim: LocalDate, $profissionalSaudeId: Long) {
  relatorioAgendamentoProducaoPorProfissionalCsv(tipoData: $tipoData, pageableDTO: $pageableDto, situacoes: $situacoes, dataInicio: $dataInicio, dataFim: $dataFim, profissionalSaudeId: $profissionalSaudeId)
}
    `,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message)
  }

  return response.data.data.relatorioAgendamentoProducaoPorProfissionalCsv;
}

export const relatorioAgendamentoProducaoPorProfissionalPdf = async (variables) => {

  const response = await Api.post("", {
    query: `
    query ($profissionalSaudeId: Long, $dataFim: LocalDate, $dataInicio: LocalDate, $situacoes: [AgendamentoSituacao], $pageableDto: PageableDTOInput, $tipoData: TipoDataRelatorio) {
  relatorioAgendamentoProducaoPorProfissionalPdf(profissionalSaudeId: $profissionalSaudeId, dataFim: $dataFim, dataInicio: $dataInicio, situacoes: $situacoes, pageableDTO: $pageableDto, tipoData: $tipoData) {
    situacao
    quantidade
    profissionalSaude
  }
}
    `,
    variables,
  });

  if (response.data.errors) {
    throw new Error(response.data.errors[0].message)
  }

  return response.data.data.relatorioAgendamentoProducaoPorProfissionalPdf;
}

export const findByUnidadeComAgenda = async({unidadeId, pageableDTO, search, ativo}) => {
  try {
    const response = await Api.post("", {
      query: `
        query FindProfissionalSaudeByUnidadeComAgendaPage($search: String, $unidadeId: Long, $pageableDTO: PageableDTOInput) {
          findProfissionalSaudeByUnidadeComAgendaPage(search: $search, unidadeId: $unidadeId, pageableDTO: $pageableDTO) {
            last
            content {
              id
              nome
            }
          }
        }
      `, 				
      variables: {
        unidadeId,
        pageableDTO,
        search,
        ...(ativo && { ativo }),
      }
    });

    if (response.data.errors) {
      throw response.data.errors[0];
    }

    return response.data.data.findProfissionalSaudeByUnidadeComAgendaPage;
  } catch (error) {
    throw error;
  }
}

export const relatorioProcedimentosAgendados = async(variables) => {
  const response = await Api.post("", {
    query: `
      query($dataInicio: LocalDate, $dataFim: LocalDate, $faturado: Boolean, $pageableDTO: PageableDTOInput, $profissionalSaudeId: Long, $convenio: ConvenioInput, $procedimento: ProcedimentoInput, $situacoes: [AgendamentoSituacao]){
        relatorioProcedimentosAgendados(dataInicio: $dataInicio, dataFim: $dataFim, faturado: $faturado, pageableDTO: $pageableDTO, profissionalSaudeId: $profissionalSaudeId, convenio: $convenio, procedimento: $procedimento, situacoes: $situacoes){
          last
          totalElements
          content {
            procedimento
            quantidade
            situacao
            valorCusto
          }
        }
      }
    `, 				
    variables: variables
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.relatorioProcedimentosAgendados;
}

export const relatorioProcedimentosAgendadosPdf = async(variables) => {
  const response = await Api.post("", {
    query: `
      query RelatorioProcedimentosAgendadosPdf($profissionalSaudeId: Long, $dataFim: LocalDate, $convenio: ConvenioInput, $faturado: Boolean, $dataInicio: LocalDate, $procedimento: ProcedimentoInput, $situacoes: [AgendamentoSituacao], $pageableDto: PageableDTOInput) {
        relatorioProcedimentosAgendadosPdf(profissionalSaudeId: $profissionalSaudeId, dataFim: $dataFim, convenio: $convenio, faturado: $faturado, dataInicio: $dataInicio, procedimento: $procedimento, situacoes: $situacoes, pageableDTO: $pageableDto) {
          valorCusto
          situacao
          quantidade
          procedimento
        }
    }
    `, 				
    variables: variables
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.relatorioProcedimentosAgendadosPdf;
}


export const relatorioProcedimentosAgendadosCsv = async(variables) => {
  const response = await Api.post("", {
    query: `
      query(
        $dataInicio: LocalDate,
        $dataFim: LocalDate,
        $profissionalSaudeId: Long,
        $situacoes: [AgendamentoSituacao],
        $faturado: Boolean
      ){
        relatorioProcedimentosAgendadosCsv(
          dataInicio: $dataInicio,
          dataFim: $dataFim,
          profissionalSaudeId: $profissionalSaudeId,
          situacoes: $situacoes,
          faturado: $faturado
        )
      }
    `, 				
    variables: variables
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.relatorioProcedimentosAgendadosCsv;
}

export const findAllConvenio = async(variables) => {
  const response = await Api.post("", {
    query: `
      query ($searchDTO: SearchDTOInput) {
        findAllConvenio(searchDTO: $searchDTO) {
          last
          content {
            id
            descricao
          }
        }
      }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }
  return response.data.data.findAllConvenio;
}

export const findAllProcedimentos = async(variables) => {
  const response = await Api.post("", {
    query: `
      query ($ativo: Boolean, $nome: String, $pageableDTO: PageableDTOInput) {
      findAllProcedimentos(ativo: $ativo, nome: $nome, pageableDTO: $pageableDTO) {
        last
        content {
          nome
          id
        }
      }
    }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }
  return response.data.data.findAllProcedimentos;
}

export const relatorioProcedimentosRealizados = async(variables) => {
  const response = await Api.post("", {
    query: `
      query($dataInicio: LocalDate, $dataFim: LocalDate, $faturado: Boolean, $pageableDTO: PageableDTOInput, $profissionalSaudeId: Long, $convenio: ConvenioInput, $procedimento: ProcedimentoInput){
        relatorioProcedimentosRealizados(dataInicio: $dataInicio, dataFim: $dataFim, faturado: $faturado, pageableDTO: $pageableDTO, profissionalSaudeId: $profissionalSaudeId, convenio: $convenio, procedimento: $procedimento){
          last
          totalElements
          content {
            procedimento
            quantidade
            valorCusto
          }
        }
      }
    `, 				
    variables: variables
  });

  if (response.data.errors) {
    throw data.errors[0];
  }

  return response.data.data.relatorioProcedimentosRealizados;
}

export const relatorioProcedimentosRealizadosPdf = async (variables) => {
  const response = await Api.post("", {
    query: `
      query($dataInicio: LocalDate, $dataFim: LocalDate, $faturado: Boolean, $pageableDTO: PageableDTOInput, $profissionalSaudeId: Long, $convenio: ConvenioInput, $procedimento: ProcedimentoInput){
        relatorioProcedimentosRealizadosPdf(dataInicio: $dataInicio, dataFim: $dataFim, faturado: $faturado, pageableDTO: $pageableDTO, profissionalSaudeId: $profissionalSaudeId, convenio: $convenio, procedimento: $procedimento){
            procedimento
            quantidade
            valorCusto
        }
      }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw data.errors[0];
  }

  return response.data.data.relatorioProcedimentosRealizadosPdf;
};

export const relatorioProcedimentosRealizadosCsv = async(variables) => {
  const response = await Api.post("", {
    query: `
      query(
        $dataInicio: LocalDate,
        $dataFim: LocalDate,
        $profissionalSaudeId: Long,
        $faturado: Boolean
      ){
        relatorioProcedimentosRealizadosCsv(
          dataInicio: $dataInicio,
          dataFim: $dataFim,
          profissionalSaudeId: $profissionalSaudeId,
          faturado: $faturado
        )
      }
    `, 				
    variables: variables
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.relatorioProcedimentosRealizadosCsv;
}

export const findAllSala = async(variables) => {
  const response = await Api.post("", {
    query: `
      query ($pageableDto: PageableDTOInput, $search: String, $ativo: Boolean) {
      findAllSala(pageableDTO: $pageableDto, search: $search, ativo: $ativo) {
        last
        content {
          id
          nome
        }
      }
    }
  `, 				
    variables: variables
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findAllSala;
}

export const findAllAgendamentoTipo = async(variables) => {
  const response = await Api.post("", {
    query: `
     query ($pageableDto: PageableDTOInput, $ativo: Boolean) {
      findAllAgendamentoTipo(pageableDTO: $pageableDto, ativo: $ativo) {
        id
        descricao
        label: descricao
        value: id
      }
    }
  `, 				
    variables: variables
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findAllAgendamentoTipo;
}

export const findByUnidadeLogadaConfiguracaoUnidade = async() => {
  const response = await Api.post("", {
    query: `
     query {
      findByUnidadeLogadaConfiguracaoUnidade {
        mostrarApenasProfissionaisAtivo
        utilizaTelefoneInternacional
        confirmaPresencaAgendamento
        utilizaValorCustoProcedimento
        utilizaMensagemPersonalizada
      }
    }
  ` 				
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findByUnidadeLogadaConfiguracaoUnidade;
}

export const relatorioTipoConsultaCountAgendamentos = async(variables) => {
  const response = await Api.post("", {
    query: `
      query (
        $dataInicio: LocalDate, 
        $dataFim: LocalDate, 
        $pageableDTO: PageableDTOInput, 
        $profissionalId: Long, 
        $tipoId: UUID, 
        $search: String, 
        $situacoes: [AgendamentoSituacao]
      ) {
        relatorioTipoConsulta(
          dataInicio: $dataInicio, 
          dataFim: $dataFim, 
          pageableDTO: $pageableDTO, 
          profissionalId: $profissionalId, 
          tipoId: $tipoId, 
          search: $search, 
          situacoes: $situacoes
        ) {
          last
          totalElements
          content {
            profissionalSaudeNome
            sujeitoAtencaoNome
            tipo
            quantidade
            situacao
          }
        }

        countAgendamentos(
          dataInicio: $dataInicio, 
          dataFim: $dataFim, 
          profissionalId: $profissionalId, 
          tipoId: $tipoId, 
          search: $search, 
          situacoes: $situacoes
        )
      }
    `, 				
    variables: variables
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return {
    relatorioTipoConsulta: response.data.data.relatorioTipoConsulta,
    countAgendamentos: response.data.data.countAgendamentos
  };
};

export const relatorioTipoConsultaPDF = async(variables) => {
  const response = await Api.post("", {
    query: `
      query RelatorioTipoConsultaPdf($tipoId: UUID, $profissionalId: Long, $search: String, $dataFim: LocalDate, $dataInicio: LocalDate, $situacoes: [AgendamentoSituacao], $pageableDto: PageableDTOInput) {
  relatorioTipoConsultaPdf(tipoId: $tipoId, profissionalId: $profissionalId, search: $search, dataFim: $dataFim, dataInicio: $dataInicio, situacoes: $situacoes, pageableDTO: $pageableDto) {
    profissionalSaudeNome
    quantidade
    quantidadeTotal
    salaNome
    situacao
    sujeitoAtencaoNome
    tipo
  }
}
    `, 				
    variables: variables
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.relatorioTipoConsultaPdf;
  
};

export const findAllAgendamentoTipoPage = async(variables) => {
  const response = await Api.post("", {
    query: `
     query ($pageableDTO: PageableDTOInput, $ativo: Boolean) {
      findAllAgendamentoTipoPage(pageableDTO: $pageableDTO, ativo: $ativo) {
        last
        content {
          id
          descricao
        }
      }
    }
  `, 				
    variables: variables
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findAllAgendamentoTipoPage;
}

export const relatorioTipoConsultaCsv = async(variables) => {
  const response = await Api.post("", {
    query: `
      query(
        $dataInicio: LocalDate,
        $dataFim: LocalDate,
        $profissionalId: Long,
        $tipoId: UUID,
        $search: String,
        $pageableDTO: PageableDTOInput,
        $situacoes: [AgendamentoSituacao]
      ){
        relatorioTipoConsultaCsv(
          dataInicio: $dataInicio,
          dataFim: $dataFim,
          profissionalId: $profissionalId,
          tipoId: $tipoId,
          search: $search,
          pageableDTO: $pageableDTO,
          situacoes: $situacoes
        )
      }
    `, 				
    variables: variables
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.relatorioTipoConsultaCsv;
}

export const findAllRelatoriosProcedimentoPeriodo = async (variables) => {
  const response = await Api.post("", {
    query: `query relatorioProcedimentosPeriodo($procedimentos: [UUID], $convenios: [Long], $dataFim: LocalDate, $sujeitoAtencaoId: UUID, $profissionalResponsavelId: Long, $profissionalSolicitanteId: Long, $dataInicio: LocalDate, $pageableDto: PageableDTOInput) {
  relatorioProcedimentosPeriodo(procedimentos: $procedimentos, convenios: $convenios, dataFim: $dataFim, sujeitoAtencaoId: $sujeitoAtencaoId, profissionalResponsavelId: $profissionalResponsavelId, profissionalSolicitanteId: $profissionalSolicitanteId, dataInicio: $dataInicio, pageableDTO: $pageableDto) {
    content {
      convenio
      dataAtendimento
      nomePaciente
      procedimento
      profissionalResponsavelNome
      profissionalSolicitanteNome
      valorCusto
    }
    last
    totalElements
  }
}`,variables
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.relatorioProcedimentosPeriodo;
  }
}

export const findAllRelatoriosProcedimentoPeriodoPdf = async (variables) => {
  const response = await Api.post("", {
    query: `query ($procedimentos: [UUID], $convenios: [Long], $dataFim: LocalDate, $sujeitoAtencaoId: UUID, $profissionalResponsavelId: Long, $profissionalSolicitanteId: Long, $dataInicio: LocalDate, $pageableDto: PageableDTOInput) {
  relatorioProcedimentosPeriodoPdf(procedimentos: $procedimentos, convenios: $convenios, dataFim: $dataFim, sujeitoAtencaoId: $sujeitoAtencaoId, profissionalResponsavelId: $profissionalResponsavelId, profissionalSolicitanteId: $profissionalSolicitanteId, dataInicio: $dataInicio, pageableDTO: $pageableDto) {
      convenio
      dataAtendimento
      nomePaciente
      procedimento
      profissionalResponsavelNome
      profissionalSolicitanteNome
      valorCusto
  }
}`,variables
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.relatorioProcedimentosPeriodoPdf;
  }
}

export const findAllSujeitoAtencao = async (variables) => {
  const response = await Api.post("", {
    query: `query FindAllSujeitoAtencao($pageable: PageableDTOInput, $searchDto: SearchSujeitoAtencaoDTOInput) {
    findAllSujeitoAtencao(pageable: $pageable, searchDTO: $searchDto) {
      content {
        id
        nome
      }
      last
    }
  }`, variables
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response
  }
}

export const relatorioProcedimentosPeriodoCsv = async (variables) => {
  const response = await Api.post("", {
    query: `query Query($profissionalResponsavelId: Long, $profissionalSolicitanteId: Long, $pageableDto: PageableDTOInput, $sujeitoAtencaoId: UUID, $dataFim: LocalDate, $convenios: [Long], $procedimentos: [UUID], $dataInicio: LocalDate) {
  relatorioProcedimentosPeriodoCsv(profissionalResponsavelId: $profissionalResponsavelId, profissionalSolicitanteId: $profissionalSolicitanteId, pageableDTO: $pageableDto, sujeitoAtencaoId: $sujeitoAtencaoId, dataFim: $dataFim, convenios: $convenios, procedimentos: $procedimentos, dataInicio: $dataInicio)
}`,variables
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  } else {
    return response.data.data.relatorioProcedimentosPeriodoCsv
  }
}

export const relatorioPacientesDuplicadosCsv = async (variables) => {
  const response = await Api.post("", {
    query: `query ($search: String, $pageable: PageableDTOInput) {
      pacientesDuplicadosCsv(search: $search, pageable: $pageable)
    }`, variables
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  } else {
    return response.data.data.pacientesDuplicadosCsv
  }
}

export const findPacienteByDocumento = async (variables) => {
  const response = await Api.post("", {
    query: `query ($documento: String, $pageable: PageableDTOInput) {
      findPacienteByDocumento(documento: $documento, pageable: $pageable) {
        id
        nome
        documento
        dataNascimento
        dataCriacao
      }
    }`, variables
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  } else {
    return response.data.data.findPacienteByDocumento
  }
}

export const findPacientesDuplicados = async (variables) => {
  const response = await Api.post("", {
    query: `query ($pageable: PageableDTOInput, $search: String) {
    findPacientesDuplicados(pageable: $pageable , search: $search) {
      last
      content {
        documento
        total
      }
    }
  }`, variables
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  } else {
    return response.data.data.findPacientesDuplicados
  }
}

export const relatorioAtendimentosPorProfissional = async (variables) => {
  const response = await Api.post("", {
    query: `query RelatorioAtendimentosPorProfissional($profissionalSaudeId: Long, $search: String, $dataFim: LocalDate, $dataInicio: LocalDate, $situacoes: [AgendamentoSituacao], $pageableDto: PageableDTOInput) {
  relatorioAtendimentosPorProfissional(profissionalSaudeId: $profissionalSaudeId, search: $search, dataFim: $dataFim, dataInicio: $dataInicio, situacoes: $situacoes, pageableDTO: $pageableDto) {
    content {
      situacao
      quantidade
      nomeProfissional
    }
    totalPages
    last
  }
}`,
    variables,
  });
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.relatorioAtendimentosPorProfissional;
  }
};

export const relatorioAtendimentosPorProfissionalPdf = async (variables) => {
  const response = await Api.post("", {
    query: `query RelatorioAtendimentosPorProfissionalPdf($profissionalSaudeId: Long, $search: String, $dataFim: LocalDate, $dataInicio: LocalDate, $situacoes: [AgendamentoSituacao], $pageableDto: PageableDTOInput) {
  relatorioAtendimentosPorProfissionalPdf(profissionalSaudeId: $profissionalSaudeId, search: $search, dataFim: $dataFim, dataInicio: $dataInicio, situacoes: $situacoes, pageableDTO: $pageableDto) {
    situacao
    quantidade
    nomeProfissional
  }
}`,
    variables,
  });
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.relatorioAtendimentosPorProfissionalPdf;
  }
};

export const relatorioAtendimentoPorProfissionalCsv = async (variables) => {
  const response = await Api.post("", {
    query: ` query relatorioAtendimentoPorProfissionalCsv(
        $dataInicio: LocalDate,
        $dataFim: LocalDate,
        $search: String,
        $pageableDTO: PageableDTOInput,
        $situacoes: [AgendamentoSituacao]
      ){
        relatorioAtendimentoPorProfissionalCsv(
          dataInicio: $dataInicio,
          dataFim: $dataFim,
          search: $search,
          pageableDTO: $pageableDTO,
          situacoes: $situacoes
        )
      }`,
    variables,
  });
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.relatorioAtendimentoPorProfissionalCsv;
  }
};

export const findAllRelatorioEncaminhamentos = async (variables) => {
  const response = await Api.post("", {
    query: `query FindAllRelatorioEncaminhamentos($search: String, $dataFim: LocalDateTime, $dataInicio: LocalDateTime, $profissionalSaudeId: Long ,$pageableDto: PageableDTOInput, $encaminhamentoModeloId: UUID) {
  findAllRelatorioEncaminhamentos(search: $search, dataFim: $dataFim, dataInicio: $dataInicio, profissionalSaudeId: $profissionalSaudeId, pageableDTO: $pageableDto, encaminhamentoModeloId: $encaminhamentoModeloId) {
    content {
      nome
      sujeitoAtencao {
        nome
      }
      id
      encaminhamentoEntidade {
        nome
      }
      profissionalSaude {
        id
        nome
      }
      dataHoraEmissao
    }
    last
    totalElements
  }
}`, variables
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.findAllRelatorioEncaminhamentos;
  }
}


export const findAllRelatorioEncaminhamentosPdf = async (variables) => {
  const response = await Api.post("", {
    query: `query findAllRelatorioEncaminhamentosPdf($search: String, $dataFim: LocalDateTime, $dataInicio: LocalDateTime, $profissionalSaudeId: Long ,$pageableDto: PageableDTOInput, $encaminhamentoModeloId: UUID) {
  findAllRelatorioEncaminhamentosPdf(search: $search, dataFim: $dataFim, dataInicio: $dataInicio, profissionalSaudeId: $profissionalSaudeId, pageableDTO: $pageableDto, encaminhamentoModeloId: $encaminhamentoModeloId) {
      nome
      sujeitoAtencao {
        nome
      }
      id
      encaminhamentoEntidade {
        nome
      }
      profissionalSaude {
        id
        nome
      }
      dataHoraEmissao
  }
}`, variables
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.findAllRelatorioEncaminhamentosPdf;
  }
}


export const relatorioEncaminhamentosCsv = async (variables) => {
  const response = await Api.post("", {
    query: `query relatorioEncaminhamentosCsv($profissionalSaudeId: Long, $search: String, $dataFim: LocalDateTime, $dataInicio: LocalDateTime) {
  relatorioEncaminhamentosCsv(profissionalSaudeId: $profissionalSaudeId, search: $search, dataFim: $dataFim, dataInicio: $dataInicio)
}`, variables
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  } else {
    return response.data.data.relatorioEncaminhamentosCsv
  }
}

export const relatorioAgendamentosCsv = async (variables) => {
  const response = await Api.post("", {
    query: `query ($search: SearchAgendamentoDTOInput) {
  relatorioAgendamentosCsv(search: $search)
}`,
    variables,
  });
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.relatorioAgendamentosCsv;
  }
};

export const relatorioAtendimentosRealizadosCsv = async (variables) => {
  const response = await Api.post("", {
    query: `query Query($dataFim: LocalDate, $dataInicio: LocalDate, $pageableDto: PageableDTOInput) {
  relatorioProcedimentoCsv(dataFim: $dataFim, dataInicio: $dataInicio, pageableDTO: $pageableDto)
}`,
    variables,
  });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.relatorioProcedimentoCsv;
  }
};

export const relatorioAniversariantesCsv = async (variables) => {
  const response = await Api.post("", {
    query: `query Query($ativo: Boolean, $search: String, $pageable: PageableDTOInput, $dataInicio: LocalDate, $municipioId: Long, $dataFinal: LocalDate) {
  relatorioAniversariantesCsv(ativo: $ativo, search: $search, pageable: $pageable, dataInicio: $dataInicio, municipioId: $municipioId, dataFinal: $dataFinal)
}`,
    variables,
  });
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.relatorioAniversariantesCsv;
  }
};

export const relatorioIndicacoesCsv = async (variables) => {
  const response = await Api.post("", {
    query: `query Query($ativo: Boolean, $search: String, $pageable: PageableDTOInput, $municipioId: Long) {
  relatorioIndicacoesCsv(ativo: $ativo, search: $search, pageable: $pageable, municipioId: $municipioId)
}`,
    variables,
  });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.relatorioIndicacoesCsv;
  }
};

export const relatorioIndicacoesPorDataCsv = async (variables) => {
  const response = await Api.post("", {
    query: `query ($pageable: PageableDTOInput, $ativo: Boolean, $search: String, $dataInicio: LocalDate, $dataFinal: LocalDate) {
  relatorioIndicacoesPorDataCsv(pageable: $pageable, ativo: $ativo, search: $search, dataInicio: $dataInicio, dataFinal: $dataFinal)
}`,
    variables,
  });
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.relatorioIndicacoesPorDataCsv;
  }
};

export const relatorioAgendamentosByCid10SubcategoriaCsv = async (
  variables
) => {
  const response = await Api.post("", {
    query: `query ($profissionalSaudeId: Long, $dataFim: LocalDate, $sujeitoAtencaoId: UUID, $cid10SubcategoriaId: Long, $dataInicio: LocalDate, $situacoes: [AgendamentoSituacao]) {
  relatorioAgendamentosByCid10SubcategoriaCsv(profissionalSaudeId: $profissionalSaudeId, dataFim: $dataFim, sujeitoAtencaoId: $sujeitoAtencaoId, cid10SubcategoriaId: $cid10SubcategoriaId, dataInicio: $dataInicio, situacoes: $situacoes)
}`,
    variables,
  });
  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  } else {
    return response.data.data.relatorioAgendamentosByCid10SubcategoriaCsv;
  }
};


export const relatorioProcedimentosOdontologicosFinalizados = async (variables) => {
  const response = await Api.post("", {
    query: `
      query($dataInicio: LocalDate, $dataFim: LocalDate, $pageableDTO: PageableDTOInput, $paciente: String, $profissionalAtendimentoId: Long, $usuarioAcao: String, $tipoAcao: String){
        relatorioProcedimentosOdontologicosFinalizados(dataInicio: $dataInicio, dataFim: $dataFim, pageableDTO: $pageableDTO, paciente: $paciente, profissionalAtendimentoId: $profissionalAtendimentoId, usuarioAcao: $usuarioAcao, tipoAcao: $tipoAcao){
          last
          totalElements
          content {
            dataHoraAcao
            tipoAcao
            usuarioAcao
            nomePaciente
            nomeProfissional
            nomeProcedimento
          }
        }
      }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.relatorioProcedimentosOdontologicosFinalizados;
};

export const relatorioProcedimentosOdontologicosFinalizadosPdf = async (variables) => {
  const response = await Api.post("", {
    query: `
      query($dataInicio: LocalDate, $dataFim: LocalDate, $pageableDTO: PageableDTOInput, $paciente: String, $profissionalAtendimentoId: Long, $usuarioAcao: String, $tipoAcao: String){
        relatorioProcedimentosOdontologicosFinalizadosPdf(dataInicio: $dataInicio, dataFim: $dataFim, pageableDTO: $pageableDTO, paciente: $paciente, profissionalAtendimentoId: $profissionalAtendimentoId, usuarioAcao: $usuarioAcao, tipoAcao: $tipoAcao){
          dataHoraAcao
          tipoAcao
          usuarioAcao
          nomePaciente
          nomeProfissional
          nomeProcedimento
        }
      }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.relatorioProcedimentosOdontologicosFinalizadosPdf;
};

export const relatorioProcedimentosOdontologicosFinalizadosCsv = async (variables) => {
  const response = await Api.post("", {
    query: `
      query($dataInicio: LocalDate, $dataFim: LocalDate, $paciente: String, $profissionalAtendimentoId: Long, $usuarioAcao: String, $tipoAcao: String){
        relatorioProcedimentosOdontologicosFinalizadosCsv(dataInicio: $dataInicio, dataFim: $dataFim, paciente: $paciente, profissionalAtendimentoId: $profissionalAtendimentoId, usuarioAcao: $usuarioAcao, tipoAcao: $tipoAcao)
      }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.relatorioProcedimentosOdontologicosFinalizadosCsv;
};

export const findRelatorioProcedimentosOdontologicos = async (variables) => {
  const response = await Api.post("", {
    query: `
     query ($pageableDto: PageableDTOInput, $dataInicial: LocalDate, $dataFinal: LocalDate, $status: StatusRelatorioOdontologico, $sujeitoAtencaoId: UUID, $profissionalId: Long) {
      findRelatorioProcedimentosOdontologicos(PageableDTO: $pageableDto, dataInicial: $dataInicial, dataFinal: $dataFinal, status: $status, sujeitoAtencaoId: $sujeitoAtencaoId, profissionalId: $profissionalId) {
        content {
          status
          profissionalExecutanteNome
          procedimentoNome
          pacienteNome
          dataHoraLancamento
          dataHoraFinalizacao
          profissionalExecucao
          dataExecucao
        }
        last
      }
    }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findRelatorioProcedimentosOdontologicos;
};

export const findRelatorioProcedimentosOdontologicosPdf = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($pageableDto: PageableDTOInput, $dataInicial: LocalDate, $dataFinal: LocalDate, $profissionalId: Long, $sujeitoAtencaoId: UUID, $status: StatusRelatorioOdontologico) {
      findRelatorioProcedimentosOdontologicosPdf(PageableDTO: $pageableDto, dataInicial: $dataInicial, dataFinal: $dataFinal, profissionalId: $profissionalId, sujeitoAtencaoId: $sujeitoAtencaoId, status: $status) {
        status
        profissionalExecutanteNome
        procedimentoNome
        pacienteNome
        dataHoraLancamento
        dataHoraFinalizacao
        profissionalExecucao
        dataExecucao
      }
    }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findRelatorioProcedimentosOdontologicosPdf;
};

export const findRelatorioProcedimentosOdontologicosCsv = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($dataFinal: LocalDate, $pageableDto: PageableDTOInput, $dataInicial: LocalDate, $profissionalId: Long, $sujeitoAtencaoId: UUID, $status: StatusRelatorioOdontologico) {
      findRelatorioProcedimentosOdontologicosCsv(dataFinal: $dataFinal, PageableDTO: $pageableDto, dataInicial: $dataInicial, profissionalId: $profissionalId, sujeitoAtencaoId: $sujeitoAtencaoId, status: $status)
    }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findRelatorioProcedimentosOdontologicosCsv;
};
